import * as React from "react";

function SvgSlant2InvertedShadow(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 200" filter="url(#slant-2-inverted-shadow_svg__a)" enableBackground="new 0 0 1600 200" {...props}><filter id="slant-2-inverted-shadow_svg__a"><feGaussianBlur in="SourceAlpha" stdDeviation={4} /><feComponentTransfer><feFuncA type="linear" slope={0.4} /></feComponentTransfer><feMerge><feMergeNode /><feMergeNode in="SourceGraphic" /></feMerge></filter><path d="M800 41.1L-10 160v10L800 51.1 1610 170v-10z" /></svg>;
}

export default SvgSlant2InvertedShadow;